/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef, useState, useEffect } from 'react';
import pt from 'date-fns/locale/pt';

import ReactDatePicker, {
  ReactDatePickerProps,
  registerLocale,
} from 'react-datepicker';

import { useField } from '@unform/core';
import { Container, Error, Label } from './styles';
import 'react-datepicker/dist/react-datepicker.css';

interface DatePickerProps extends Omit<ReactDatePickerProps, 'onChange'> {
  name: string;
  label: string;
  placeholder: string;
}

registerLocale('pt', pt);

const DatePicker: React.FC<DatePickerProps> = ({
  name,
  label,
  placeholder,

  ...rest
}) => {
  const datepickerRef = useRef(null);
  const { fieldName, registerField, defaultValue, error } = useField(name);
  const [date, setDate] = useState(defaultValue || null);
  const [isCorrect] = useState(false);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: datepickerRef.current,
      path: 'props.selected',
      clearValue: (ref: any) => {
        ref.clear();
      },
    });
  }, [fieldName, registerField]);

  return (
    <>
      <Label htmlFor={name}>{label}</Label>
      <Container>
        <ReactDatePicker
          locale="pt"
          dateFormat="P"
          ref={datepickerRef}
          selected={date}
          onChange={setDate}
          placeholderText={placeholder}
          {...rest}
        />
      </Container>
      {!isCorrect && <Error>{error}</Error>}
    </>
  );
};

export default DatePicker;
